var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('head-bar',{on:{"sidebar":_vm.handleSidebar}})],1),_c('el-container',[_c('el-aside',{attrs:{"width":_vm.isCollapse ? '64px' : '280px'}},[_c('side-bar',{attrs:{"is-collapse":_vm.isCollapse}})],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }